export default __webpack_public_path__ + "static/RobotoMono-italic-b39a11f9a6107e57a21f0c399cd3218b.woff2";